export default "__VITE_ASSET__CAbKcLUq__"